import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DialogButton } from '../../../models/enums/dialogbutton.enum';
import { InterceptorSkipHeader } from '../../../services/interceptor.skip.header';
import { BaseDialog } from '../../dialogs/basedialog/base.dialog';

/** Shows assets/third-party-notices.json, generated by Tools/third-party-notices/erzeugen.py. */
@Component({
    selector: 'thirdparty-notices-control',
    templateUrl: './thirdparty.notices.control.html',
    styleUrls: ['./thirdparty.notices.control.css']
})
export class ThirdPartyNoticesControl implements OnInit {
    Components = [];
    Filtered = [];
    Texts = {};
    FilterText = '';
    Selected: any;

    static ShowDialog() {
        BaseDialog.ShowDialog({
            ContentType: ThirdPartyNoticesControl,
            Buttons: DialogButton.Ok,
            FullScreen: true,
            AutoFocus: false,
            Title: '@@Third-party licenses'
        });
    }

    constructor(private cdRef: ChangeDetectorRef, private http: HttpClient) {
    }

    ngOnInit(): void {
        const headers = new HttpHeaders().set(InterceptorSkipHeader, '');
        this.http.get('assets/third-party-notices.json', { headers }).subscribe((x: any) => {
            if (x) {
                this.Components = x.Komponenten ?? [];
                this.Texts = x.Texte ?? {};
                this.applyFilter();
            }
        });
    }

    applyFilter() {
        const f = (this.FilterText ?? '').toLowerCase();
        this.Filtered = f ? this.Components.filter(c =>
            c.Name.toLowerCase().includes(f) || (c.Lizenz ?? '').toLowerCase().includes(f)) : this.Components;
        this.cdRef.detectChanges();
    }

    onItemClick(data: any) {
        this.Selected = data;
        this.cdRef.detectChanges();
    }

    getText(data: any) {
        return data?.Text ? this.Texts[data.Text] : '';
    }
}
